module.exports = __webpack_public_path__ + "static/media/incytBanner.60e21ffe.jpg";